export default __webpack_public_path__ + "static/media/CHAdeMO.7cc311e7.svg";